import { Alert, AlertProps, AlertTitle, Typography, Button } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { NavLink } from 'react-router-dom'
import { User } from '../types'

export interface UserSmsNotificationsDisabledWarningAlertProps
  extends Omit<AlertProps, 'children' | 'severity'> {
  user: User
}

export default function UserSmsNotificationsDisabledWarningAlert({
  user,
  ...props
}: UserSmsNotificationsDisabledWarningAlertProps) {
  /**
   * The translate function.
   */
  const { t } = useTranslation('common')

  /**
   * Indicates if the current user has SMS notifications enabled.
   */
  const smsNotificationsEnabled = user.notificationsBySms

  return (
    <>
      {!smsNotificationsEnabled && (
        <Alert severity="warning" {...props}>
          <AlertTitle>{t('smsNotificationsDisabled')}</AlertTitle>
          <Typography>{t('smsNotificationsDisabledWarning')}</Typography>
          <Button
            component={NavLink}
            to={`/users/${user.id}#notifications`}
            variant="outlined"
            color="warning"
            size="small"
            sx={{ mt: 2 }}
          >
            {t('goToNotificationSettings')}
          </Button>
        </Alert>
      )}
    </>
  )
}
